import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { TextField } from "@material-ui/core";
import { Container, Row, Col } from "shards-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomToolbar from "../common/AddButton";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddAlertIcon from "@material-ui/icons/AddAlert";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
//import { Store } from "../../flux";
import api from "../common/api";

class MobileUsers extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      backdrop: false,
      users: [],
      reset_emails: []
    };
  }

  async componentDidMount() {
    await this.getUsers();
  }

  getUsers() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.mobileUsers().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, users: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, users: [] });
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        },
        MuiFormLabel: {
          root: {
            fontSize: "0.75rem"
          }
        },
        MuiInputBase: {
          root: {
            fontSize: "0.75rem"
          }
        },
        MuiTypography: {
          body1: {
            fontSize: "0.75rem"
          }
        }
      }
    });

  handleDelete(e, id) {
    e.preventDefault();
    this.state.users.map((val, idx) => {
      if (val.id === id) {
        this.setState({ delete_id: val.id });
      }
    });

    var message = "";
    if (id !== "") {
      message = "Está a punto de dar de baja al usuario. ¿Está seguro?";
    } else {
      message = "Hubo un problema al dar de baja al usuario.";
    }
    this.setState({ message: message, dialogOpen: true });
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.href = `/mobile/users`;
  }

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  handleDownload = async () => {
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    await axios
      .post(api.mobileUsers().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
        this.handleCloseBackdrop();
        this.setState({ isLoaded: true });
      })
      .catch(error => {
        alert("Falló la descarga");
        this.setState({ isLoaded: true });
      });
  };

  sendResetPassword = async () => {
    await this.state.reset_emails.map((val, idx) => {
      this.handleResetPassword(val);
    });

    this.setState({
      dialogOpen: true,
      message:
        "Se han enviado los mails de reseto a los usuarios seleccionados",
      reset_emails: []
    });
  };
  handleResetPassword = async email => {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    formData.set("email", email);
    axios
      .post(api.resendPassword, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {})
      .catch(function(error) {});
  };

  confirmDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(api.users().delete(this.state.delete_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ message: "Usuario dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: "" });
      });
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true,
          display: false
        }
      },
      {
        name: "subcontact.contact.hansa_code",
        label: "Hansa Code",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: true
        }
      },
      {
        name: "subcontact.firstname",
        label: "Nombre",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "subcontact.lastname",
        label: "Apellido",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "mobileData.created_at",
        label: "Fecha de alta APP",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false,
          filterType: "custom",
          customFilterListOptions: {
            render: v => {
              if (v[0] && v[1]) {
                return [`${v[0]}`, `${v[1]}`];
              } else if (v[0]) {
                return `${v[0]}`;
              } else if (v[1]) {
                return `${v[1]}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }

              return filterList;
            }
          },
          filterOptions: {
            names: [],
            logic(created_at, filters) {
              //				var min = (filters[0]) ? new Date(filters[0].split('-')[2],filters[0].split('-')[1]-1,filters[0].split('-')[0]) : null
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var created_at = created_at ? created_at.split("T")[0] : null;
              created_at = created_at
                ? new Date(
                    created_at.split("-")[0],
                    created_at.split("-")[1] - 1,
                    created_at.split("-")[2]
                  )
                : null;
              if (min && max) {
                return !(created_at >= min && created_at <= max);
              } else if (min) {
                return !(created_at >= min);
              }
              if (max) {
                return !(created_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha alta desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha alta hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "mobileData.last_connected_at",
        label: "Última conexión",
        options: {
          filter: true,
          filterType: "custom",
          sort: true,
          display: false,
          customFilterListOptions: {
            render: v => {
              if (v[0] && v[1]) {
                return [`${v[0]}`, `${v[1]}`];
              } else if (v[0]) {
                return `${v[0]}`;
              } else if (v[1]) {
                return `${v[1]}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }

              return filterList;
            }
          },
          filterOptions: {
            names: [],
            logic(last_connected_at, filters) {
              //				var min = (filters[0]) ? new Date(filters[0].split('-')[2],filters[0].split('-')[1]-1,filters[0].split('-')[0]) : null
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var last_connected_at = last_connected_at
                ? last_connected_at.split(" ")[0]
                : null;
              last_connected_at = last_connected_at
                ? new Date(
                    last_connected_at.split("-")[0],
                    last_connected_at.split("-")[1] - 1,
                    last_connected_at.split("-")[2]
                  )
                : null;
              if (min && max) {
                return !(last_connected_at >= min && last_connected_at <= max);
              } else if (min) {
                return !(last_connected_at >= min);
              }
              if (max) {
                return !(last_connected_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha ult conexion desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha ult conexion hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "mobileData.last_doc_sync_at",
        label: "Última sync de docs",
        options: {
          filter: true,
          filterType: "custom",
          sort: true,
          display: false,
          customFilterListOptions: {
            render: v => {
              if (v[0] && v[1]) {
                return [`${v[0]}`, `${v[1]}`];
              } else if (v[0]) {
                return `${v[0]}`;
              } else if (v[1]) {
                return `${v[1]}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }

              return filterList;
            }
          },
          filterOptions: {
            names: [],
            logic(last_doc_sync_at, filters) {
              //				var min = (filters[0]) ? new Date(filters[0].split('-')[2],filters[0].split('-')[1]-1,filters[0].split('-')[0]) : null
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var last_doc_sync_at = last_doc_sync_at
                ? last_doc_sync_at.split(" ")[0]
                : null;
              last_doc_sync_at = last_doc_sync_at
                ? new Date(
                    last_doc_sync_at.split("-")[0],
                    last_doc_sync_at.split("-")[1] - 1,
                    last_doc_sync_at.split("-")[2]
                  )
                : null;
              if (min && max) {
                return !(last_doc_sync_at >= min && last_doc_sync_at <= max);
              } else if (min) {
                return !(last_doc_sync_at >= min);
              }
              if (max) {
                return !(last_doc_sync_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha ult sync desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha ult sync hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "mobileData.recentlyConnected",
        label: "Operativo",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          display: false
        }
      },
      {
        name: "state",
        label: "Estado",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          display: false
        }
      },
      {
        name: "client",
        label: "Cliente",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          display: false
        }
      },
      {
        name: "mobileData.name",
        label: "Dispositivo",
        options: {
          filter: false,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "mobileData.operating_system",
        label: "Sistema operativo",
        options: {
          filter: false,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "mobileData.operating_system_version",
        label: "Sistema opearativo version",
        options: {
          filter: false,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "subcontact.id",
        label: "Id Subcontacto",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "vehicle.plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "vehicle.description",
        label: "Marca/Modelo/Version",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "vehicle.state_name",
        label: "Estado Vehiculo",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          display: false
        }
      },
      {
        name: "can_login",
        label: "Tiene permisos ",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          display: false
        }
      },
      {
        name: "Acciones",
        label: "",
        options: {
          filter: false,
          setCellHeaderProps: () => ({ align: "center" }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            const userID = tableMeta.rowData[1];
            const subcontactID = tableMeta.rowData[14];
            //const rowId = 1
            return (
              <div className="row" style={{ display: "block" }}>
                {rowId ? (
                  <Fab
                    color="primary"
                    aria-label="view"
                    variant="extended"
                    style={{ boxShadow: "none", backgroundColor: "green" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    href={"user/" + subcontactID}
                  >
                    <EditIcon fontSize="small" />
                  </Fab>
                ) : (
                  ""
                )}
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"/push/notification/" + rowId}
                >
                  <AddAlertIcon />
                </Fab>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  onClick={e => {
                    this.handleDelete(e, rowId);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </Fab>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: true,
      download: true,
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      rowsPerPage: 10,
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
        var user_list = "";
        var reset_emails = [];
        for (let index = 0; index < selectedRows.data.length; index++) {
          const element = selectedRows.data[index];
          var user = displayData[element.index];
          user_list += user.data[0] + ",";
          reset_emails.push(user.data[4]);
        }
        user_list = user_list.replace(/,\s*$/, "");
        return (
          <React.Fragment>
            <div className="ml-2">
              <Tooltip title={"Resetear password"}>
                <IconButton
                  onClick={() =>
                    this.setState({
                      reset_emails: reset_emails,
                      dialogOpen: true,
                      message:
                        "Esta seguro de enviar contraseñas nuevas a los usuarios seleccionados ?"
                    })
                  }
                >
                  <RefreshIcon
                    onClick={() =>
                      this.setState({
                        reset_emails: reset_emails,
                        dialogOpen: true,
                        message:
                          "Esta seguro de enviar contraseñas nuevas a los usuarios seleccionados ?"
                      })
                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Enviar notificacion"}>
                <IconButton
                  onClick={e => {
                    window.location.href = "/push/notification/" + user_list;
                  }}
                >
                  <AddAlertIcon />
                </IconButton>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Administracion usuarios
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.delete_id === "" ||
                    this.state.reset_emails.length === 0 ? (
                      <div>
                        <Button
                          onClick={e => {
                            this.handleRefresh(e);
                          }}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={
                            this.state.reset_emails.length > 0
                              ? this.sendResetPassword()
                              : this.confirmDelete.bind(this)
                          }
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <div>
              <Backdrop
                open={this.state.backdrop}
                onClick={this.handleCloseBackdrop}
                style={{ zIndex: 10000, color: "#3f51b5" }}
              >
                <CircularProgress color="inherit" />{" "}
                <Typography className="ml-2" variant="h5" color="primary">
                  Descargando...
                </Typography>
              </Backdrop>
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Usuarios Mobile"
                  data={Object.values(this.state.users)}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MobileUsers;
